export * from './src/multilingual-translation-v1-content-translation-contents.meta.js';
